/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */



document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant;
  if (!variant) return;

  for (var i = 1; i <= 3; i++) {
    var value = variant['option' + i];
    if (!value) continue;
    document.querySelectorAll('.product-form__option-value').forEach(function(span) {
      span.textContent = value; // <-- Use textContent, not innerHTML
    });
  }
});

// Move product-image-zoom to document.body to fix z-index/stacking context issues.
// The element is originally nested inside product-media, which can be inside stacking
// contexts (transforms from reveal animations, flickity, etc.) that prevent it from
// appearing above all other elements. Moving to body puts it in the root stacking context.
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('product-image-zoom').forEach(function(zoom) {
    var mediaElement = zoom.closest('.product__media');
    if (!mediaElement) return; // already moved or not found
    document.body.appendChild(zoom); // move to body (triggers connectedCallback which nulls mediaElement)
    zoom.mediaElement = mediaElement; // restore the reference immediately after
  });
});

// Shadow DOM font family inheritance fix
document.addEventListener('DOMContentLoaded', function() {
  // Function to inject styles into Shadow DOM
  function injectShadowDOMStyles() {
    // Target shopify-payment-terms
    const paymentTerms = document.querySelector('shopify-payment-terms');
    if (paymentTerms && paymentTerms.shadowRoot) {
      const style = document.createElement('style');
      style.textContent = `
        * {
          font-family: inherit !important;
        }
      `;
      paymentTerms.shadowRoot.appendChild(style);
    }
    
    // Target shopify-installments
    const installments = document.querySelector('#shopify-installments');
    if (installments && installments.shadowRoot) {
      const style = document.createElement('style');
      style.textContent = `
        * {
          font-family: inherit !important;
        }
      `;
      installments.shadowRoot.appendChild(style);
    }
  }
  
  // Try immediately and after a delay
  injectShadowDOMStyles();
  setTimeout(injectShadowDOMStyles, 1000);
  
  // Also try when payment elements are loaded
  document.addEventListener('shopify:payment_button:loaded', injectShadowDOMStyles);
});

// Hide Gorgias chat widget when mega menu / nav dropdown is open
(function() {
  function updateMenuOpenState() {
    var shopItem = document.querySelector('[data-item-title="SHOP"] > .header__linklist-link[aria-expanded="true"]');
    if (shopItem) {
      document.body.classList.add('mega-menu-open');
    } else {
      document.body.classList.remove('mega-menu-open');
    }
  }

  var observer = new MutationObserver(updateMenuOpenState);
  document.addEventListener('DOMContentLoaded', function() {
    var shopLink = document.querySelector('[data-item-title="SHOP"] > .header__linklist-link[aria-controls]');
    if (shopLink) {
      observer.observe(shopLink, { attributes: true, attributeFilter: ['aria-expanded'] });
    }
  });
})();

// Header more menu - close on outside click
(function() {
  const moreMenu = document.getElementById('header-more-menu');
  if (moreMenu) {
    document.addEventListener('click', function(e) {
      if (moreMenu.open && !moreMenu.contains(e.target)) {
        moreMenu.open = false;
      }
    });
  }
})();

// plasmaSOMES Micro-Needle Kit landing page (PageFly page pf-88d9b52c)
// The two "Get My Kit — $99" CTAs are anchors that only scrolled down to the
// buy box. Make them add to cart instead by delegating the click to the
// page's own Add To Cart button, rather than posting to /cart/add.js
// ourselves: that way Rebuy's flyout, the free-gift app and every other
// integration hanging off that button behave exactly as they do from the buy
// box. If the button is missing or disabled we leave the click alone and the
// anchor falls back to its original scroll.
(function() {
  var PAGE = '__pf_PPTdHrnQ';
  if (!document.querySelector('.' + PAGE)) return;

  var CTA = '.' + PAGE + ' .pf-19_, .' + PAGE + ' .pf-90_';
  var ATC = '.' + PAGE + ' .pf-235_, .' + PAGE + ' .pf-298_';

  // Capture phase: PageFly's own handler on these anchors (the
  // data-to-section scroll) calls stopPropagation, so a bubble-phase
  // listener on document never runs.
  document.addEventListener('click', function(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var cta = target.closest(CTA);
    if (!cta || cta.getAttribute('aria-busy') === 'true') return;

    var addToCart = document.querySelector(ATC);
    if (!addToCart || addToCart.disabled) return;

    // Suppress PageFly's scroll-to-section as well: adding to cart opens
    // Rebuy's flyout, and scrolling the page behind it is just noise.
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    cta.setAttribute('aria-busy', 'true');
    addToCart.click();

    window.setTimeout(function() {
      cta.removeAttribute('aria-busy');
    }, 1500);
  }, true);
})();
